import { formatName } from '../../utils';
import { Avatar } from '@nexelem/components';

type TableAvatarWithNameProps = {
  firstName?: string;
  lastName?: string;
  fullName?: string;
  testId?: string;
};

export const TableAvatarWithName = ({ fullName, firstName, lastName }: TableAvatarWithNameProps) => {
  const formattedValue = fullName ?? formatName(firstName || '', lastName || '');
  const [firstNameFormatted, lastNameFormatted] = formattedValue.split(' ');

  return (
    <div className="flex h-full items-center gap-2">
      <Avatar firstName={firstNameFormatted} lastName={lastNameFormatted} />
      <span className="text-s16">{formattedValue}</span>
    </div>
  );
};
